import React from 'react'

type Props = {
  disabled: boolean
  submitting: boolean
  displayText: string
  className?: string
  buttonColor?: string
  buttonActionType?: 'button' | 'submit'
  onClick?: () => void
}

export const AncientButtonSubmit: React.FC<Props> = ({
  disabled,
  submitting,
  displayText,
  className,
  buttonColor,
  buttonActionType = 'submit',
  onClick,
}) => {
  const buttonProps: React.ButtonHTMLAttributes<HTMLButtonElement> = {
    type: buttonActionType,
    className: 'btn ' + className + ' ' + (buttonColor != undefined ? buttonColor : 'btn-primary'),
    disabled,
  }
  if (onClick) {
    buttonProps.onClick = onClick
  }
  return (
    <button {...buttonProps}>
      {!submitting && displayText}
      {submitting && (
        <span className='indicator-progress' style={{display: 'block'}}>
          Please wait...{' '}
          <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
        </span>
      )}
    </button>
  )
}
